import { useTranslation } from 'react-i18next';
import { IFitoList } from '~/Components/FitoList/FitoListUncontrolled/interfaces';
import { Route } from '~/Constants/Routes.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { useNavigation, useProvider } from '~/Hooks';
import { ILocation } from '~/Models/DTO/Location.models';
import { selectLocationList } from '~/store/provider';
import { addressFormatter } from './addressFormatter';
import { ILocationWithStatus } from '~/Models/interfaces/Location.model';
import { LocationStatus } from '~/Models/DTO/externalParties.model';
import { statusType } from '~/ScreensOrganisation/OrganisationStudio/OrgStudioList.model';

export const useProviderLocations = () => {
  const { t } = useTranslation();
  const { currentProvider } = useProvider();
  const { navigate } = useNavigation();

  const keyOfId: keyof ILocation = 'uuid';
  const settings = { search: true, rearrange: true, pagination: true };

  const createListItem = ({ id, name, city, zipCode, street, status }: ILocationWithStatus) => ({
    header: name,
    subheader: addressFormatter({ street, city, zipCode }),
    onClick: () => {
      navigate(routeReplacer(Route.PROVIDER_LOCATIONS_EDIT, { id }));
    },
    status: status && {
      label: t(`organisation.location.status.${LocationStatus[status]}`),
      color: statusType[status],
    },
  });

  const setItemValues = (item: ILocation): IFitoList => createListItem(item);

  const listReduxSelectorString = selectLocationList;

  const goToLocationCreation = () => navigate(Route.PROVIDER_LOCATIONS_CREATE);

  const defaultQuery = { domain: currentProvider?.domain || '' };

  return {
    title: t('settings.locations'),
    keyOfId,
    settings,
    setItemValues,
    listReduxSelectorString,
    goToLocationCreation,
    defaultQuery,
  };
};
